import React from 'react';
import LegalPage, { LegalSection as Section } from '../components/LegalPage';

const Privacy = () => (
  <LegalPage
    title="Privacy Policy"
    description="WASLX privacy policy — how we collect, use, store, and protect your data. Learn about your rights, data retention, call recordings, and how to contact us."
    path="/privacy"
    heading="Privacy Policy"
    updated="April 27, 2025"
  >
    <>
        <Section title="1. Who we are">
          <p>WASLX ("we", "our", "us") is a mobile-first call center platform operated by WASLX. We are committed to protecting the personal information of our users, agents, and customers.</p>
          <p>For questions about this policy, contact us at <strong>hello@waslx.co.in</strong>.</p>
        </Section>

        <Section title="2. Information we collect">
          <p><strong>Account data:</strong> When you sign up, we collect your name, company name, email address, and phone number.</p>
          <p><strong>Lead data:</strong> Information you upload about the contacts your team calls — names, phone numbers, emails, and any custom fields you configure.</p>
          <p><strong>Call data:</strong> Call logs, duration, outcomes (dispositions), and call recordings where enabled by your organisation.</p>
          <p><strong>Usage data:</strong> How you and your agents interact with the WASLX platform (feature usage, login times, device type).</p>
          <p><strong>Device data (mobile app):</strong> The WASLX Android app collects device model, OS version, and SIM information to enable calling features.</p>
        </Section>

        <Section title="3. How we use your information">
          <p>We use your information to:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Provide, maintain, and improve the WASLX platform.</li>
            <li>Process and facilitate calls made through the platform.</li>
            <li>Send transactional emails (account confirmations, password resets).</li>
            <li>Respond to support requests.</li>
            <li>Monitor platform performance and troubleshoot issues.</li>
            <li>Comply with legal obligations.</li>
          </ul>
          <p>We do not sell your personal data to third parties.</p>
        </Section>

        <Section title="4. Call recordings">
          <p>Call recordings are stored securely and are only accessible to authorised users within your organisation (subject to the permissions you configure). We do not listen to or process recordings except where required for technical support you have requested.</p>
          <p>It is your organisation's responsibility to ensure that call recording complies with applicable local laws, including informing called parties where required.</p>
        </Section>

        <Section title="5. Data storage and security">
          <p>Your data is stored on secure cloud infrastructure. We apply industry-standard security measures including encryption in transit (HTTPS/TLS) and access controls.</p>
          <p>During the beta period, data is stored in India. We will update this policy if storage regions change.</p>
        </Section>

        <Section title="6. Data retention">
          <p>We retain your account data for as long as your account is active. Call logs and recordings are retained for up to 90 days by default, after which they are deleted unless your plan specifies otherwise. You may request earlier deletion by contacting us.</p>
        </Section>

        <Section title="7. Your rights">
          <p>You have the right to:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Access the personal data we hold about you.</li>
            <li>Correct inaccurate data.</li>
            <li>Request deletion of your data (subject to legal obligations).</li>
            <li>Export your data in a portable format.</li>
          </ul>
          <p>To exercise any of these rights, email <strong>hello@waslx.co.in</strong>.</p>
        </Section>

        <Section title="8. Cookies">
          <p>Our website uses essential cookies to maintain your session and remember your preferences. We do not use advertising or tracking cookies. See our Cookie Policy for details.</p>
        </Section>

        <Section title="9. Changes to this policy">
          <p>We may update this Privacy Policy from time to time. We will notify you of material changes by email or by posting a notice on the platform. Continued use of WASLX after changes constitutes acceptance of the updated policy.</p>
        </Section>

        <Section title="10. Contact">
          <p>Questions? Email us at <strong>hello@waslx.co.in</strong> or write to us via the Contact page.</p>
        </Section>
    </>
  </LegalPage>
);

export default Privacy;
